import { render, staticRenderFns } from "./personSurcharge.vue?vue&type=template&id=7af44f55&"
import script from "./personSurcharge.vue?vue&type=script&lang=js&"
export * from "./personSurcharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7af44f55')) {
      api.createRecord('7af44f55', component.options)
    } else {
      api.reload('7af44f55', component.options)
    }
    module.hot.accept("./personSurcharge.vue?vue&type=template&id=7af44f55&", function () {
      api.rerender('7af44f55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25zFodfR0dA13/JS/personSurcharge.vue"
export default component.exports